export const dataLibStLucia = [{
  word: 'Sent Lisi',
  partOfSpeech: 'N',
  definition: ['Saint Lucia'],
  egSentenceKw: 'Yo ka alé Sent Lisi pou Kannaval.',
  egSentenceEn: 'They are going to St. Lucia for Karnival.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. Sainte Lucie]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Babonno',
  partOfSpeech: 'N',
  definition: ['Babonneau'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Bèson',
  partOfSpeech: 'N',
  definition: ['Bexon'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Chwazèy',
  partOfSpeech: 'N',
  definition: ['Choiseul'],
  egSentenceKw: 'Sé péchè Chwazèy-la toujou ka tjébé an chay volan.',
  egSentenceEn: 'The Choiseul fishermen always catch a lot of flying fish.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['Swazèy'],
}, {
  word: 'Swazèy',
  partOfSpeech: 'N',
  definition: ['Choiseul'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['Chwazèy'],
}, {
  word: 'Dennwi',
  partOfSpeech: 'N',
  definition: ['Dennery'],
  egSentenceKw: 'Dennwi sé on koté ki benyen jan lanmè.',
  egSentenceEn: 'Dennery is a place full of fishermen.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Déwiso',
  partOfSpeech: 'N',
  definition: ['Dérisseaux'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Gwozilé',
  partOfSpeech: 'N',
  definition: ['Gros Ilet'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Kannawi',
  partOfSpeech: 'N',
  definition: ['Canaries'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Kastwi',
  partOfSpeech: 'N',
  definition: ['Castries'],
  egSentenceKw: 'Yo ka alé Kastwi vitman ay fè on konmisyon.',
  egSentenceEn: 'They\'re going to Castries to do a quick errand.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Labowi',
  partOfSpeech: 'N',
  definition: ['Laborie'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Lanslawé',
  partOfSpeech: 'N',
  definition: ['Anse la Raye'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Mikou',
  partOfSpeech: 'N',
  definition: ['Micoud'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Ojé',
  partOfSpeech: 'N',
  definition: ['Augier'],
  egSentenceKw: 'Yo tout ka wèsté Ojé pwé lopital-la.',
  egSentenceEn: 'They all live in Augier near the hospital.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. Augier]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Pwalen',
  partOfSpeech: 'N',
  definition: ['Praslin'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'Soufwiyè',
  partOfSpeech: 'N',
  definition: ['Soufrière'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['Soufouyè'],
}, {
  word: 'Soufouyè',
  partOfSpeech: 'N',
  definition: ['Soufrière'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['Soufwiyè'],
}, {
  word: 'Vyé Fò',
  partOfSpeech: 'N',
  definition: ['Vieux Fort'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
},
];
